module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="source_icon ' +
((__t = ( getSourceIcon() )) == null ? '' : __t) +
'" style="display:none;"></div>';

}
return __p
}